import React from "react";
import { formatDate, toId } from "../../utils/markschedule/marksHelpers";
import ExamTypeBadge from "../examsschedule/ExamTypeBadge";
import TeacherSubjectSelect from "./TeacherSubjectSelect";
import {
  Button,
  Select,
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Alert,
} from "../../components/ui";

/**
 * One eligible completed schedule for marks assignment.
 * Section = from class sections API.
 * Teacher = TeacherSubjectAssignment only (via TeacherSubjectSelect).
 */
export default function EligibleScheduleCard({
  item,
  sections = [],
  selectedSectionId,
  selectedStaffId,
  onSectionChange,
  onStaffChange,
  onAssign,
  assigning = false,
  canAssign = true,
  isPortal = false,
}) {
  const schedule = item.schedule || item;
  const exam = item.exam || {};
  const existing = item.existingAssignments || [];
  const scheduleId = toId(schedule);
  const subjectId = toId(schedule.subjectId);

  const sectionOptions = [
    { label: "Select section", value: "" },
    ...sections.map((s) => ({
      label: s.sectionName || s.name,
      value: toId(s),
    })),
  ];

  return (
    <Card className="hover:border-neutral-300 transition-colors">
      <CardHeader className="pb-3">
        <div className="flex flex-wrap items-start justify-between gap-2">
          <div>
            <CardTitle className="text-base font-semibold text-neutral-900 dark:text-neutral-100">
              {item.examName || exam.name || "Exam"}
            </CardTitle>
            <div className="text-xs text-neutral-500 dark:text-neutral-400 mt-1 flex flex-wrap gap-2 items-center">
              <ExamTypeBadge type={item.examType || exam.type} />
              <span>
                {schedule.subjectId?.name || "Subject"} ·{" "}
                {schedule.classId?.className || "Class"}
              </span>
              <span>{formatDate(schedule.examDate)}</span>
              <span className="font-medium text-neutral-700 dark:text-neutral-200">
                Max {item.maxMarks ?? schedule.maxMarks}
              </span>
            </div>
          </div>
        </div>
      </CardHeader>

      <CardContent className="space-y-3 pt-0">
        {existing.length > 0 && (
          <Alert variant="warning" size="sm">
            Already assigned for {existing.length} section(s)
          </Alert>
        )}

        {canAssign && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 items-end pt-1">
            <Select
              label="Section"
              options={sectionOptions}
              value={selectedSectionId || ""}
              onChange={(val) => onSectionChange?.(val)}
            />

            <TeacherSubjectSelect
              isPortal={isPortal}
              scheduleId={scheduleId}
              subjectId={subjectId}
              sectionId={selectedSectionId || ""}
              value={selectedStaffId || ""}
              onChange={onStaffChange}
              label="Teacher (subject assignment)"
            />

            <Button
              type="button"
              variant="primary"
              disabled={assigning || !selectedSectionId || !selectedStaffId}
              isLoading={assigning}
              onClick={() => onAssign?.(scheduleId)}
              className="w-full"
            >
              Assign marks
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
}